import * as React from 'react';
import { withNativeProps } from '@/utils/with-native-props';
import './cn-tag-group.scss';
export const CnTagGroup = (props) => {
    return withNativeProps(props, React.createElement("div", { className: "cn-ui-m-tag-group" }, props.children));
};
CnTagGroup.displayName = 'CnTagGroup';
